// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"phchV7","withBorder":"bzSjPK","filter":"tGZ0oW"};